import { useTranslation } from 'react-i18next';

import { Field, FieldDescription, FieldLabel } from '@/components/ui/field';
import { Skeleton } from '@/components/ui/skeleton';

import { BuildInfo } from '@/entities/layout';

interface BuildInfoFieldProps {
  isLoading: boolean;
  buildInfo?: BuildInfo;
}

export const BuildInfoField = ({ isLoading, buildInfo }: BuildInfoFieldProps) => {
  const { t } = useTranslation();

  return (
    <Field>
      <FieldLabel>{t('footer.build.label', 'Built')}</FieldLabel>
      {isLoading ? (
        <Skeleton className="h-5 w-80" />
      ) : (
        <FieldDescription>
          Git branch: {buildInfo?.gitBranch} ({buildInfo?.gitCommit}) Build date: {buildInfo?.buildTime}
        </FieldDescription>
      )}
    </Field>
  );
};
